import { render, staticRenderFns } from "./AuthButtons.vue?vue&type=template&id=56492754&scoped=true"
import script from "./AuthButtons.vue?vue&type=script&lang=js"
export * from "./AuthButtons.vue?vue&type=script&lang=js"
import style0 from "./AuthButtons.vue?vue&type=style&index=0&id=56492754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56492754",
  null
  
)

export default component.exports